import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading, Select } from "components/form";
import * as Icons from "react-feather";
import { required, validationWrapper, number } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useList } from "store/list";
import { handleSuccessMessages } from "store/auth";
import AddSlide from "./AddSlide";
import EditSlide from "./EditSlide";

import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { useCore } from "store/core";
import cleanObject from "utils/editHelper";
import { cleanArray } from "utils/editHelper";
import { getCategories } from "store/core";
import { getCategoriesNew } from "store/core";
import { GalleryField } from "components/form";
// components

export default function Add(props) {
  const path = {
    baseRoute: "/show-panel",
    aliasName: "صفحه ها",
    type: "Shows",
  };
  const navigator = useNavigate();
  const {
    dispatch,
    clear,
    load,
    update,
    getSingle,
    single,
    customRequest,
  } = useList();
  const [slides, setSlides] = useState([]);
  const [showAddSlide, setShowAddSlide] = useState(false);
  const [showEditSlide, setShowEditSlide] = useState(false);
  const [item, setItem] = useState(false);
  const { id } = useParams();
  const onSortEnd = async ({ oldIndex, newIndex }) => {
    setSlides(single.data.categories);
    setItem(single.data);

    handleSuccessMessages("عملیات با موفقیت انجام شد");
  };

  const handleDeleteSlide = (item_id) => {
    const updatedSlides = slides?.filter((slide) => slide?.id !== item_id);
    setSlides(updatedSlides);

    handleSuccessMessages("عملیات با موفقیت انجام شد");
  };

  useEffect(() => {
    dispatch(getSingle(path, id));
    dispatch(getCategoriesNew("filter[type][$eq]=News"));
  }, []);

  useEffect(() => {
    if (single && single?.data?.categories) {
      setSlides(single?.data?.categories);
      setItem(single?.data);
    }
  }, [single]);

  if (load) {
    return (
      <>
        <div className="content">
          <div className="p-3 flex justify-center">
            <Loading />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <AddSlide
        slides={slides}
        setSlides={setSlides}
        show={showAddSlide}
        close={() => setShowAddSlide(false)}
        submit={async (values) => {
          setSlides([...slides, values]);
          handleSuccessMessages("عملیات با موفقیت انجام شد");
        }}
      />

      <EditSlide
        slides={slides}
        setSlides={setSlides}
        show={showEditSlide}
        item={item}
        close={() => setShowEditSlide(false)}
        submit={async (values) => {
          handleSuccessMessages("عملیات با موفقیت انجام شد");
        }}
      />

      <div className="content">
        <div className="w-full p-3 flex justify-between items-center">
          <h2>ایجاد صفحه</h2>
          <Link to="/settings/Shows" className="btn btn-info shadow-md mr-2">
            بازگشت
          </Link>
        </div>

        <hr className="my-3" />
        <div className="p-3 w-full flex gap-x-2">
          <div className="w-1/4">
            <Formik
              initialValues={{ ...single?.data }}
              onSubmit={async (values, { setSubmitting }) => {
                // delete values.slides;

                const clean = cleanObject(values, [
                  "id",
                  "updatedAt",
                  "uuid",
                  "createdAt",
                ]);

                const newSlides = cleanArray(slides, [
                  "id",
                  "updatedAt",
                  "createdAt",
                ]);
                clean.categories = newSlides;

                await dispatch(
                  update(path, id, clean, () => {
                    handleSuccessMessages("عملیات با موفقیت انجام شد");
                    navigator("/settings/Shows");
                  })
                );
                setSubmitting(false);
              }}
              enableReinitialize
            >
              {({ isSubmitting, dirty }) => (
                <Form>
                  <div className="box rounded py-3">
                    <div className="p-3">
                      <div className="intro-x flex-col">
                        <Field
                          placeholder="نام صفحه"
                          label="نام صفحه :"
                          name="pageName"
                          component={TextField}
                          validate={(value) =>
                            validationWrapper(value, required)
                          }
                        />

                        <button
                          className="mt-4 btn btn-primary w-20"
                          type="submit"
                          // disabled={!!(isSubmitting || !dirty)}
                        >
                          {isSubmitting ? <Loading /> : "ذخیره"}
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>

          <div className="w-3/4">
            <div className="box p-2">
              <div className="flex justify-between md:px-4 items-center">
                <h3>صفحه ها : </h3>
                <button
                  className="btn btn-primary btn-sm my-3"
                  onClick={() => {
                    setShowAddSlide(true);
                  }}
                >
                  ایجاد صفحه
                </button>
              </div>
              <hr className="my-2" />

              {/* slides List */}
              <div className="mt-3">
                <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
                  <table className="table table-report text-xs -mt-2">
                    <thead>
                      <tr>
                        <th className="whitespace-nowrap text-center">
                          اولویت
                        </th>

                        <th className="whitespace-nowrap text-center">
                          عنوان دسته
                        </th>

                        <th className="whitespace-nowrap text-center">
                          محل نمایش
                        </th>
                        <th className="whitespace-nowrap text-center">
                          عملیات
                        </th>
                      </tr>
                    </thead>

                    {slides && slides?.length > 0 && (
                      <SortableList
                        items={slides}
                        onSortEnd={onSortEnd}
                        setItem={(item) => {
                          setItem(item);
                        }}
                        setShowEditSlide={(value) => setShowEditSlide(value)}
                        handleDeleteSlide={handleDeleteSlide}
                      />
                    )}
                  </table>
                </div>
              </div>
              {/* slides List */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const SortableList = SortableContainer((props) => {
  const { items, handleDeleteSlide } = props;

  return (
    <tbody>
      {items?.map((item, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          item={item}
          setItem={props.setItem}
          setShowEditSlide={props.setShowEditSlide}
          handleDeleteSlide={handleDeleteSlide}
        />
      ))}
    </tbody>
  );
});
const SortableItem = SortableElement((props) => {
  const core = useCore();
  const { item, handleDeleteSlide } = props;

  const matchedCategory = core?.categories?.find(
    (category) => category?.value === item?.category
  );

  return (
    <tr className="intro-x cursor-pointer select-none">
      <td className="text-center">{item?.displayPriority}</td>

      <td className="text-center">
        {matchedCategory?.label.replace(/News/g, "").trim()} - {item?.type}
      </td>

      <td className="text-center">{item?.displayLocation}</td>

      <td className="text-center">
        <button
          className="flex items-center ml-3 cursor-pointer"
          onClick={() => {
            props.setItem(item);
            props.setShowEditSlide(true);
          }}
        >
          <Icons.CheckSquare className="w-4 h-4 mb-2 ml-1" />
          ویرایش
        </button>

        <button
          className="flex items-center text-theme-6 cursor-pointer"
          onClick={() => handleDeleteSlide(item?.id)}
        >
          <Icons.Trash2 className="w-4 h-4 ml-1 " />
          حذف
        </button>
      </td>
    </tr>
  );
});
